/* unplugin-vue-components disabled */import { render } from "./ActPage4.vue?vue&type=template&id=4a531206&scoped=true"
import script from "./ActPage4.vue?vue&type=script&lang=js"
export * from "./ActPage4.vue?vue&type=script&lang=js"

import "./ActPage4.vue?vue&type=style&index=0&id=4a531206&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a531206"]])

export default __exports__